const CaretRight = () => (
  <svg
    className="app"
    width="8"
    height="16"
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.630256 15.3254C0.431407 15.1929 0.299946 14.9957 0.264794 14.7772C0.229642 14.5586 0.293678 14.3366 0.442816 14.16L5.69116 8L0.442815 1.84C0.293678 1.66339 0.229642 1.44138 0.264794 1.22282C0.299946 1.00427 0.431406 0.807066 0.630256 0.674601C0.729274 0.606403 0.842684 0.556532 0.963778 0.52794C1.08487 0.499348 1.21119 0.492615 1.33527 0.508136C1.45934 0.523658 1.57865 0.561119 1.68615 0.618308C1.79364 0.675496 1.88713 0.751249 1.96108 0.841086L7.50933 7.3507C7.66896 7.53747 7.75537 7.76551 7.75537 8C7.75537 8.23449 7.66896 8.46253 7.50933 8.6493L1.96109 15.1589C1.88713 15.2488 1.79364 15.3245 1.68615 15.3817C1.57865 15.4389 1.45934 15.4763 1.33527 15.4919C1.21119 15.5074 1.08487 15.5007 0.963779 15.4721C0.842685 15.4435 0.729275 15.3936 0.630256 15.3254Z"
    />
  </svg>
);

export default CaretRight;
